<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="search" :reset="reset"></queryCondition>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog">新建</el-button>
                    <!-- <el-button type="primary" icon="el-icon-edit" size="small" @click="updateDialogShow()">修改人员信息</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="角色名称"
                align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                >
                </el-table-column> -->
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteRole(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" :title="title" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        角色名称:
                    </div>
                    <el-input v-model="addData.name" size="small" placeholder="请输入角色名称"></el-input>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addRole">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" :title="title" width="400px">
            <div class="dialog" v-if="isUpdateDialog">
                <div class="item">
                    <div class="label">
                        角色名称:
                    </div>
                    <el-input v-model="updateData.name" size="small" placeholder="请输入角色名称"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateRole">确 定</el-button>
                </div>
            </div>
        </el-dialog>

       
    </div>
</template>
<script>
import api from '../../../api/base'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
           queryList:[
                {
                    type: "input",
                    label: "角色名称:",
                    name: "name",
                },
            ],
            conditionData: {
                name: "",
                page:1,
                pageSize:10
            }, 

            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            addData:{},
            updateData:{},
            tableData:[],
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.roleList(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;

        },
        search(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        
        reset(){
            this.conditionData = {
                name:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增角色';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.addRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }
        },
        async deleteRole(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRoleFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteRoleFun(row){
            let res  = await api.delRole(row);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async updateRole(){
            let res  = await api.editRole(this.updateData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑角色信息';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
